import BasicLayout from '@/layouts/basic-layout'

const prefix = 'storage-manage-termination-bill-'
export default [
  {
    path: '/storage-manage/termination-bill',
    component: BasicLayout,
    children: [
      {
        path: 'detail-create',
        name: `${prefix}create`,
        auth: ['hidden'],
        meta: {title: '业主解约结算单新增'},
        component: () => import('@/pages/storage-manage/termination-bill/detail-create')
      },
      {
        path: 'detail-edit/:id',
        name: `${prefix}edit`,
        auth: ['hidden'],
        meta: {cache: true, title: '业主解约结算单编辑'},
        component: () => import('@/pages/storage-manage/termination-bill/detail-edit')
      },
      {
        path: 'detail-view/:id',
        name: `${prefix}view`,
        auth: ['hidden'],
        meta: {title: '业主解约结算单详情'},
        component: () => import('@/pages/storage-manage/termination-bill/detail-view')
      }
    ]
  }
]
